<template>
    <footer class="app-nav">
        <ul class="items container">
            <li><router-link class="item" :to="{ name: 'about' }" exact>ABOUT</router-link></li>
            <li><router-link class="item" :to="{ name: 'coupon' }">COUPON</router-link></li>
            <li><router-link class="item" :class="{ 'router-link-active': $route.name === 'spot' }" :to="{ name: 'map' }">MAP</router-link></li>
            <li><router-link class="item" :to="{ name: 'programs' }">PROGRAM</router-link></li>
        </ul>
    </footer>
</template>

<script>
export default {
    name: 'AppNav'
}
</script>

<style scoped lang="scss">
@import '~@/styles/_parts';

.app-nav {
    backface-visibility: hidden;
    background: #24154b;
    color: #fff;
    font-family: 'Fugaz One', cursive;
    font-size: em(13);
    line-height: em(56, 13);
    transition: background 275ms $ease;
    @include g-text-shadow();
    @include media(768) {
        font-size: em(20);
        line-height: em(70, 20);
    }
    @include media(992) {
        &._force-bg {
            background: #24154b !important;
        }
    }
}
.items {
    display: flex;
    align-items: center;
    justify-content: center;
    > li + li {
        margin-left: em(36, 13);
    }
}
.item {
    opacity: .5;
    &.router-link-active {
        opacity: 1;
    }
}
</style>